<div class="mrr-tabs-wrapper">
  <div class="mrr-tab-nav">
    <div class="tab-track">
      <button
        *ngFor="let tab of tabs"
        class="mrr-tab-btn"
        [class.active]="activeTabId === tab.id"
        (click)="selectTab(tab.id)"
        [attr.aria-selected]="activeTabId === tab.id"
        type="button"
      >
        <span class="tab-icon-wrap">
          <i class="fa {{ tab.icon }}"></i>
        </span>
        <span class="tab-label">{{ tab.label }}</span>
      </button>
    </div>
  </div>

  <div class="mrr-tab-panel">
    <div *ngIf="loading" class="state-container loading-state">
      <div class="spinner-wrap">
        <div class="spinner-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <p class="state-title">Loading data</p>
      <p class="state-sub">Fetching {{ activeTab.label }} records&hellip;</p>
    </div>

    <div *ngIf="!loading && error" class="state-container error-state">
      <div class="state-icon-wrap error-icon">
        <i class="fa fa-exclamation-triangle"></i>
      </div>
      <p class="state-title">Something went wrong</p>
      <p class="state-sub">{{ error }}</p>
      <button class="btn-ghost-sm" (click)="loadTab(activeTabId)" type="button">
        <i class="fa fa-refresh"></i>&nbsp;Try again
      </button>
    </div>

    <div
      *ngIf="!loading && !error && tableData.length === 0"
      class="state-container empty-state"
    >
      <div class="state-icon-wrap empty-icon">
        <i class="fa fa-folder-open-o"></i>
      </div>
      <p class="state-title">No records found</p>
      <p class="state-sub">{{ activeTab.emptyMessage }}</p>
    </div>

    <div *ngIf="!loading && !error && tableData.length > 0" class="mrr-toolbar">
      <div class="toolbar-left">
        <span class="toolbar-label">{{ activeTab.label }}</span>
        <span class="toolbar-count"
          >{{ tableData.length }} record{{
            tableData.length !== 1 ? "s" : ""
          }}</span
        >
      </div>
      <div class="toolbar-right">
        <button
          class="btn-delete-all"
          (click)="openDeleteConfirm()"
          type="button"
          title="Delete all records"
        >
          <i class="fa fa-trash"></i>
          <span>Delete All</span>
        </button>
      </div>
    </div>

    <div
      *ngIf="!loading && !error && tableData.length > 0"
      class="table-responsive mrr-table-container"
    >
      <table class="mrr-data-table">
        <thead>
          <tr>
            <th class="col-sl">#</th>
            <th *ngFor="let h of activeTab.headers" [style.width]="h.width">
              {{ h.name }}
            </th>
            <th class="col-actions">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let row of tableData; let i = index"
            class="data-row"
            [class.row-deleting]="deletingIndex === i"
          >
            <td class="col-sl">{{ i + 1 }}</td>
            <td
              *ngFor="let h of activeTab.headers"
              [ngClass]="cellClass(row[h.id], h.id)"
            >
              <ng-container *ngIf="h.id === 'isMrr'; else discountCell">
                <span
                  class="status-badge"
                  [ngClass]="row[h.id] ? 'badge-applied' : 'badge-not'"
                >
                  <span class="badge-dot"></span>
                  {{ row[h.id] ? "Applied" : "Not Applied" }}
                </span>
              </ng-container>
              <ng-template #discountCell>
                <ng-container
                  *ngIf="
                    h.id === 'perc' || h.id === 'mrrDiscount';
                    else defaultCell
                  "
                >
                  <span class="pct-chip">
                    {{
                      row[h.id] !== null &&
                      row[h.id] !== undefined &&
                      row[h.id] !== ""
                        ? row[h.id] + "%"
                        : "—"
                    }}
                  </span>
                </ng-container>
              </ng-template>
              <ng-template #defaultCell>
                <span class="cell-text">
                  {{
                    row[h.id] !== null &&
                    row[h.id] !== undefined &&
                    row[h.id] !== ""
                      ? row[h.id]
                      : "—"
                  }}
                </span>
              </ng-template>
            </td>

            <td class="col-actions">
              <div class="row-actions">
                <button
                  class="act-btn act-edit"
                  (click)="editRow(row, i)"
                  title="Edit record"
                  type="button"
                >
                  <i class="fa fa-pencil"></i>
                </button>
                <button
                  class="act-btn act-delete"
                  (click)="deleteRow(row, i)"
                  title="Delete record"
                  type="button"
                  [disabled]="deletingIndex === i"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="table-footer">
        <span class="footer-info">
          <i class="fa fa-table"></i>&nbsp; Showing
          <strong>{{ tableData.length }}</strong> {{ activeTab.label }} record{{
            tableData.length !== 1 ? "s" : ""
          }}
        </span>
      </div>
    </div>

    <div *ngIf="isEditOpen">
      <new-all-update
        [activeTabId]="editTabId"
        [data]="selectedRow"
        [action]="'update'"
        [mrr]="selectedRow"
        [mrrDatasub]="{ type: editTabId }"
        [mrrData]="tableData"
        [mid]="mid"
        [unsaved]="[]"
        (hideModel)="onEditClose($event)"
      ></new-all-update>
    </div>
  </div>
</div>

<!-- DELETE ALL MODAL — rendered via native DOM, zero Angular event involvement -->
<div id="deleteConfirmModal" ...>...</div>
